export const NAME = 'toolbar';

export const INIT_TOOLBAR_REQUEST = 'INIT_TOOLBAR_REQUEST';
export const INIT_TOOLBAR_SUCCESS = 'INIT_TOOLBAR_SUCCESS';
export const INIT_TOOLBAR_FAILURE = 'INIT_TOOLBAR_FAILURE';

export const URL_CHROME =
    'https://chrome.google.com/webstore/detail/malic%C3%A9a/afgipdldjblgfejcohhkpjbjjadpnaif?hl=fr';
export const URL_FIREFOX = 'https://secure.malicea.com/toolbar/FF/malicea.xpi';
export const URL_EDGE = '';
export const URL_SAFARI = '';



// WEBPACK FOOTER //
// ./src/services/toolbar/constants.js